import { LIGHT_THEME, DARK_THEME } from '../styleConstants';
import createBreakpoints from './createBreakpoints';

export const colorPalette = {
  light: {
    colors: {
      type: LIGHT_THEME,
      name: LIGHT_THEME,
      base: '#fcfcfc',
      notfnHover: '#E6E6E6',
      white: '#fff',
      whiteV2: '#fff',
      whiteV3: '#fff',
      whiteV4: '#fcfcfc',
      whiteV5: '#F0F4F7',

      offWhiteV2: '#fff',

      green: '#08bd80',
      darkGreen: '#07a872',

      darkRed: '#d64f4f',

      fontGrey: '#3C4852',
      fontGreyV2: '#3C4852',
      fontGreyV3: '#3C4852',
      fontLightGrey: '#808080',
      fontLightGreyV2: '#808080',

      dropShadow: '#f0f4f7',
      dropShadowV2: '#f0f4f7',
      dropShadowV4: '#f0f4f7',
      dropShadowV5: 'rgba(221, 230, 237, 0.4)',
      dropShadowV6: 'f1f5f7',

      fontLightBlue: '#dde6ed',
      fontLightBlueV2: '#dde6ed',
      fontDarkBlue: '#9aafbf',
      fontDarkBlueV3: '#9aafbf',
      fontDarkBlueV4: '#9aafbf',
      fontDarkBlueV5: '#9aafbf',
      blue: '#2d81f7',
      red: '#eb5757',
      orange: '#FFAD3B',
      orangeV2: '#EE900D',
      streakOngoing: 'rgba(255,173,59,0.2)',
      streakPrevious: 'rgba(154, 175, 191, 0.20)',
      transparentBlack: 'rgba(0, 0, 0, 0.3)',
      disabled: 'rgba(154,175,191,0.4)'
    },
    opacity: {
      base: 1
    }
  },
  dark: {
    colors: {
      name: DARK_THEME,
      type: DARK_THEME,
      base: '#131417',
      notfnHover: '#202022',
      white: '#202022',
      whiteV2: '#fff',
      whiteV3: '#2C2C2E',
      whiteV4: '#2C2C2E',

      fontLightBlueV2: '#2C2C2E',
      offWhiteV2: '#ebebf5',
      green: '#08BD80',
      darkGreen: '#07a872',

      darkRed: '#d64f4f',

      fontGrey: '#EBEBF5',
      fontGreyV2: 'rgb(235,235,245,.6)',
      fontGreyV3: '#2c2c2e',
      fontLightGrey: 'rgb(235,235,245,.6)',
      fontLightGreyV2: '#EBEBF5',

      dropShadow: 'rgb(0,0,0,.1)',
      dropShadowV2: '#2c2c2e',
      dropShadowV4: '#38383A',
      dropShadowV5: 'rgba(0, 0, 0, 0.2)',
      dropShadowV6: '#363636',

      fontLightBlue: '#38383A',
      fontDarkBlue: 'rgba(235,235,245,0.6)',
      fontDarkBlueV3: '#EBEBF5',
      fontDarkBlueV4: '#9aafbf',
      fontDarkBlueV5: '#8f8f8f',

      blue: '#41A0FF',
      red: '#eb5757',
      orange: '#FFAD3B',
      orangeV2: '#EE900D',
      streakOngoing: 'rgba(255,173,59,0.2)',
      streakPrevious: 'rgba(154, 175, 191, 0.20)',
      transparentBlack: 'rgba(0, 0, 0, 0.3)',
      disabled: 'rgba(154,175,191,0.4)'
    },
    opacity: {
      base: 0.5
    }
  }
};

export default function getTheme(mode) {
  return {
    breakpoints: createBreakpoints(),
    colors: colorPalette[mode ? 'dark' : 'light'].colors,
    opactiy: colorPalette[mode ? 'dark' : 'light'].opacity
  };
}
